























































































import { Component, Prop, Vue } from "vue-property-decorator";
import { userModule } from "@/store/modules/user";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import CpptRanapStore from "@/store/modules/CpptRanapStore";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { storeSoap } from "@/store/modules/soap";
import CardCatatanSoap from "@/components/pemeriksaan/soap/CardCatatanSOAP.vue";
import CardDPP from "@/components/pemeriksaan/soap/CardDPP.vue";
import AdimeInput from "@/components/soap/AdimeInput.vue";
import HandOverInput from "@/components/soap/HandOverInput.vue";
import ReadBackInput from "@/components/soap/ReadBackInput.vue";
import CpptIntegratedList from "@/components/soap/CpptIntegratedList.vue";
import SoapInput from "@/components/soap/SoapInput.vue";
import SoapListRecords from "@/components/soap/SoapListRecords.vue";

@Component({
  components: {
    CardCatatanSoap,
    CardDPP,
    AdimeInput,
    HandOverInput,
    ReadBackInput,
    CpptIntegratedList,
    SoapInput,
    SoapListRecords
  },
  inject: {
    pageIsReadOnly: { from: "isReadOnly", default: () => () => false }
  }
})
export default class CpptRalanPage extends Vue {
  @Prop() register!: string;
  @Prop() rm!: string;
  @Prop({ default: null }) copySoap!: object;
  @Prop({ type: String, default: "tab-soap" }) readonly defaultTab!: string;
  pageIsReadOnly!: () => boolean;

  tab = this.defaultTab;

  soapItem = null;
  adimeItem = null;
  handoverItem = null;
  readbackItem = null;

  get soapMulti(): boolean {
    return ["2H", "38"].includes(this.stateUser.unit_id);
  }

  get isReadonly(): boolean {
    return this.pageIsReadOnly();
  }

  get stateUser() {
    return userModule.user;
  }

  get registerId(): number {
    return parseInt(this.$route.params.register);
  }

  get statesoapdata() {
    return storeSoap.soap["data"] ? storeSoap.soap["data"][0] : null;
  }

  get registerKunjungan() {
    return RegisterKunjungan.register;
  }

  get isDpjp(): boolean {
    return this.registerKunjungan?.dokter?.id == this.stateUser.id;
  }

  async getByRegister() {
    if (this.stateUser.isMedis) {
      await SoapRanapStore.getByRegister(this.registerId);
      await CpptRanapStore.getAdimeByRegister(this.registerId);
      await CpptRanapStore.getReadbackByRegister(this.registerId);
    } else {
      await CpptRanapStore.getHandoverByRegister(this.registerId);
    }
  }

  makeNewSoap(cat = "soap") {
    const key = `${cat}Item`;
    if (key in this) {
      this.tab = `tab-${cat}`;
      this[key] = null;
    } else if (cat === "soap") {
      this.tab = "tab-soap";
    }
  }

  putItem(cat: string, item: any) {
    const key = `${cat}Item`;
    if (key in this) {
      this.tab = `tab-${cat}`;
      this.$nextTick(() => {
        setTimeout(() => {
          this[key] = item;
        }, 100);
      });
    }
  }

  putSoapItem(item) {
    this.soapItem = item;
  }

  gotoSoapTab(item = null) {
    this.tab = "tab-soap";
    if (this.soapMulti && item) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.soapItem = item;
        }, 100);
      });
    }
  }
}
